import { API_URL } from 'shared/api/Constants'; 
import { apiInterceptor } from './axios';

export const validateSession = async (): Promise<void> => {
  try {
    await apiInterceptor.get(API_URL.PING);
  } catch (error) {
  // Intentionally ignored.
  // 401 + refresh handled in axios interceptor.
  // If refresh fails, logout is triggered there.
  }
};